import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { HexagonGridAnimation } from '../blasts/HexagonGrid';

registerCollisionAnimation('CYBER_HEX', (ctx, e, config, progress) => {
  HexagonGridAnimation(ctx, e as any, config, progress);
});
